import { useCallback, useEffect, useState } from "react";

/**
 * Persisted boolean toggle stored in localStorage.
 * Useful for collapsible section state.
 */
export function useCollapsed(key, defaultCollapsed = false) {
  const storageKey = `sniper.collapsed.${key}`;

  const [collapsed, setCollapsed] = useState(() => {
    try {
      const v = localStorage.getItem(storageKey);
      if (v === null) return defaultCollapsed;
      return v === "1";
    } catch {
      return defaultCollapsed;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(storageKey, collapsed ? "1" : "0");
    } catch {
      /* ignore */
    }
  }, [collapsed, storageKey]);

  const toggle = useCallback(() => setCollapsed((c) => !c), []);
  return [collapsed, toggle];
}
